import headerLogo from '../assets/dwarf.png';
import { RouteNames } from './AppRouter';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../provider/AuthProvider';
import { useState } from 'react';

function Header() {
    const { token, setToken, isSuperAdmin } = useAuth();
    const navigate = useNavigate();
    const isAuthenticated = !!token;
    const [isMenuActive, setIsMenuActive] = useState(false);

    const handleLogout = (event) => {
        event.preventDefault();
        setToken(null);
        navigate(RouteNames.login);
    };

    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
    };

    return (
        <div className="hero-head">
            <nav className="navbar">
                <div className="container">
                    <div className="navbar-brand">
                        <Link to={isAuthenticated ? RouteNames.myComics : RouteNames.login} className="navbar-item">
                            <img src={headerLogo} alt="Logo" />
                            <h2>Les bibliothèques d'Aquilon</h2>
                        </Link>
                        <span 
                            className={`navbar-burger burger ${isMenuActive ? 'is-active' : ''}`}
                            data-target="navbarMenu"
                            onClick={toggleMenu}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </div>
                    <div id="navbarMenu" className={`navbar-menu ${isMenuActive ? 'is-active' : ''}`}>
                        <div className="navbar-end">
                            <div className="tabs is-right">
                                <ul>
                                    {!isAuthenticated && <li><Link to={RouteNames.login}>Connexion</Link></li>}
                                    {!isAuthenticated && <li><Link to={RouteNames.register}>Inscription</Link></li>}
                                    {isAuthenticated && <li><Link to={RouteNames.myComics}>Ma collection</Link></li>}
                                    {isAuthenticated && <li><Link to={RouteNames.share}>Partager</Link></li>}
                                    {isAuthenticated && isSuperAdmin && <li><Link to={RouteNames.admin}>Admin</Link></li>}
                                    {isAuthenticated && <li><Link to={RouteNames.login} onClick={handleLogout}>Déconnexion</Link></li>}
                                    <li><Link to={RouteNames.about}>À propos</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default Header;
